import { render, staticRenderFns } from "./TuiJianList.vue?vue&type=template&id=58cd0a50&scoped=true&"
import script from "./TuiJianList.vue?vue&type=script&lang=js&"
export * from "./TuiJianList.vue?vue&type=script&lang=js&"
import style0 from "./TuiJianList.vue?vue&type=style&index=0&id=58cd0a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd0a50",
  null
  
)

export default component.exports